/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Download_EventInputs */



/**
* | output |
* | --- |
* | "Download a copy of the event" |
*
* @param {Tools_Download_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_download_event = /** @type {((inputs?: Tools_Download_EventInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Download_EventInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger une copie de l'événement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar una copia del evento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar uma cópia do evento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica una copia dell'evento")
	return /** @type {LocalizedString} */ ("Download a copy of the event")
});